import { render, staticRenderFns } from "./IndustryDetails.vue?vue&type=template&id=2e1cf766&"
import script from "./IndustryDetails.vue?vue&type=script&lang=js&"
export * from "./IndustryDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports